import { render, staticRenderFns } from "./confluence.vue?vue&type=template&id=aeefca0a&scoped=true"
import script from "./confluence.vue?vue&type=script&lang=js"
export * from "./confluence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefca0a",
  null
  
)

export default component.exports